import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Package } from "@phosphor-icons/react";

const fmtDT = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "—");
const daysSince = (iso) => (iso ? Math.floor((Date.now() - new Date(iso).getTime()) / 86400000) : null);

export function UndeliveredTranslationsCard() {
  const { data = [] } = useQuery({
    queryKey: ["dashboard", "undelivered-translations"],
    queryFn: async () => (await api.get("/dashboard/undelivered-translations")).data,
  });
  if (!data.length) return null;
  return (
    <div className="card-flat p-5 mb-8 border-l-4 border-l-amber-400" data-testid="undelivered-translations-card">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Package size={18} weight="duotone" className="text-amber-600" />
          <div className="font-semibold text-slate-900">{data.length} paid translation{data.length > 1 ? "s" : ""} not yet received</div>
        </div>
        <Link to="/translations" className="text-xs font-medium text-[#1E3A8A] hover:underline" data-testid="undelivered-view-all">Open Translations →</Link>
      </div>
      <div className="text-xs text-slate-500 mb-2">Released after payment but not downloaded, confirmed, or picked up.</div>
      <ul className="divide-y divide-slate-100">
        {data.map((p) => {
          const d = daysSince(p.released_at);
          return (
            <li key={p.project_id} className="py-2 flex flex-wrap items-center justify-between gap-2 text-sm" data-testid={`undelivered-row-${p.project_id}`}>
              <div className="min-w-0">
                <div className="font-medium text-slate-900 truncate">{p.title}</div>
                <div className="text-xs text-slate-500">{p.client_name || "—"} · {p.files} file{p.files > 1 ? "s" : ""} · released {fmtDT(p.released_at)}</div>
              </div>
              <div className="flex items-center gap-2 text-xs">
                <span className={`badge-pill ${p.opened ? "bg-sky-50 text-sky-800 border-sky-200" : "bg-slate-100 text-slate-600 border-slate-200"}`}>
                  {p.email_status === "bounced" ? "Email bounced" : p.opened ? "Email opened" : "Not opened"}
                </span>
                {d !== null && <span className={`badge-pill ${d >= 5 ? "bg-red-50 text-red-700 border-red-200" : "bg-amber-50 text-amber-800 border-amber-200"}`}>{d}d waiting</span>}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
